module.exports = __webpack_public_path__ + "static/media/animals.b8d3eeb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/animals.jpg
// module id = 191
// module chunks = 0